import React from 'react';
import { Table } from 'react-bootstrap';

const TariffTable = () => {
    return (
        <Table>
            <thead>
                <tr>
                    <th>Omschrijving</th>
                    <th>Tariff nummer</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Rode wijn {"<"}15% {"<"}2L </td>
                    <td>22042184</td>
                </tr>
                <tr>
                    <td>Witte wijn {"<"}15% {"<"}2L</td>
                    <td>22042183</td>
                </tr>
                <tr>
                    <td>Wijn tussen 15% en 18% {"<"}2L</td>
                    <td>22042191</td>
                </tr>
                <tr>
                    <td>Mousserende wijn</td>
                    <td>22041098</td>
                </tr>
                <tr>
                    <td>Bier {"<"}10L verpakt in flessen</td>
                    <td>22030001</td>
                </tr>
                <tr>
                    <td>Gedestilleerde dranken {"<"}80%</td>
                    <td>2208XXXX</td>
                </tr>
            </tbody>
        </Table>
    );
}

export default TariffTable;